const CALORIES_FIELD_KEY_REGEX = /^([a-z]+)\[(\d+)\]$/i

export const PriceDiet = (json: IPriceDietMeal): IPriceDietMealModel => {
	const { price, ...rest } = json

	return {
		price: price || price === 0 ? price / 100 : null,
		...rest,
	}
}

export const priceDietToJSON = (obj: Partial<IPriceDietMealModel>): Partial<IPriceDietMeal> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}

export const PriceDietToPayload = (event: IFormSubmitEvent<IPriceDietForm>) => {
	const objectByCalories: Record<number, IPriceDietMealPayload> = {}
	Object.keys(event.values).forEach(key => {
		const match = key.match(CALORIES_FIELD_KEY_REGEX)
		if (!match) return

		const propName = match[1] // 'price' or 'points'
		const kcal = Number.parseInt(match[2], 10)

		if (!objectByCalories[kcal]) {
			objectByCalories[kcal] = { kcal }
		}

		// @ts-ignore kcal cannot be dynamic key
		objectByCalories[kcal][propName] =
			propName === 'price' ? PriceToPayload(event.values[key]) : Number(event.values[key])
	})

	// Convert object to array
	return Object.values(objectByCalories)
}
